<div class="container">
  <!-- Title -->
  <div class="text-center">
    <strong class="mainHeading slide-in-left">City Details  </strong>
  </div>
 
  <!-- Toolbar -->
  <div class="row slide-up">
    <!-- Buttons -->
    <div
      class="col-lg-9 col-md-9 col-sm-12 toolbar d-flex align-items-center gap-2"
    >
      <button
        *ngIf="loginData.userType == 6"
        class="btn btn-primary"
        (click)="openCreateCityModal(createCityModal)"
        ngbTooltip="Create City"
        tooltipClass="custom-tooltip"
      >
        <span><i class="bi bi-plus"></i></span> Create
      </button>
      <button
        class="btn btn-success"
        (click)="exportToExcel()"
        ngbTooltip="Export to excel"
      >
        <span><i class="bi bi-box-arrow-up me-2"></i></span> Export
      </button>
      <button
        class="btn btn-success"
        (click)="exportToPDF()"
        ngbTooltip="Print"
      >
        <span><i class="bi bi-printer me-2"></i></span>Print
      </button>
      <button
        class="btn btn-success"
        (click)="clearGrid(searchInput)"
        ngbTooltip="Clear filter"
      >
        <span> <i class="bi bi-x-circle me-2"></i></span>Clear Filter
      </button>
    </div>
  </div>
 
  <!-- Table Card -->
  <div class="card shadow-lg p-3 slide-up">
    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-3"
    >
      <h2 class="mb-0">City List</h2>
      <div class="col-lg-3 col-md-4 col-sm-12 mt-2 mt-md-0">
        <input
        #searchInput
          type="text"
          class="form-control"
          placeholder="Search"
          [(ngModel)]="searchKey"
          (input)="search($event)"
        />
      </div>
    </div>
    <!-- Responsive Table Wrapper -->
    <div class="table-responsive">
      <table class="table table-striped table-bordered text-center mb-0">
        <thead class="table-light">
          <tr>
            <!-- <th>City ID</th> -->
              <th>S.No</th>
            <th>
              City Name
              <i class="bi bi-funnel" (click)="toggleCityFilterDropdown()"></i>
              <!-- Dropdown for City Name filter -->
              <div *ngIf="isCityFilterVisible" class="dropdown-menu show">
                <ul class="list-group">
                  <li
                    class="list-group-item"
                    *ngFor="let city of cityNames"
                    (click)="filterCitiesByName(city)"
                  >
                    {{ city }}
                  </li>
                </ul>
              </div>
            </th>
            <th>Zone Name</th>
            <th>Date Created</th>
            <th class="text-center">
              <div class="d-flex justify-content-center align-items-center">
                <span>Is Active</span>
                <div class="dropdown ms-2">
                  <i
                    class="bi bi-funnel cursor-pointer"
                    id="statusFilterDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style="font-size: 1.2rem; color: #6c757d"
                  ></i>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="statusFilterDropdown"
                  >
                    <li>
                      <a class="dropdown-item" (click)="filterCities('all')"
                        >All</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" (click)="filterCities('active')"
                        >Active</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="filterCities('inactive')"
                        >Inactive</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </th>
            <th *ngIf="loginData.userType == 6">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let city of pagedData; let i = index">
            <!-- <td>{{ city.id }}</td> -->
             <td class="text-center">{{ getSerialNumber(i) }}</td>
            <td>{{ city.cityName }}</td>
            <td [routerLink]="['/zones']"><a class="hyperLink">List</a></td>
            <td>{{ city.createdDate | date : "dd MMM yyyy" }}</td>
            <td class="status-cell">
              <a
                [ngClass]="{
                  approved: city.cityStatus === true
                }"
                class="hyperLink status-link"
                (click)="openActivePopup(activePopup, city)"
              >
                <span
                  class="status-dot"
                  [ngClass]="{
                    'dot-green': city.cityStatus === true,
                    'dot-red': city.cityStatus !== true
                  }"
                ></span>
                {{ getStatus(city.cityStatus) }}
              </a>
            </td>
 
            <td class="text-center" *ngIf="loginData.userType == 6">
              <i
                class="bi bi-pencil-square text-danger"
                style="cursor: pointer"
                (click)="editItem(city, createCityModal)"
              ></i>
              <i
                class="bi bi-trash text-danger"
                style="cursor: pointer"
                (click)="openDeleteModal(city,deleteZoneModal)"
              ></i>

               <!-- <button class="deleteBtn" (click)="openDeleteModal(city?.zoneId,deleteZoneModal)">
              <span><i class="bi bi-trash me-2"></i></span> Delete
            </button> -->
            </td>
          </tr>
          <tr *ngIf="cityData?.length === 0">
            <td colspan="5" class="text-center"><app-no-data-found></app-no-data-found></td>
            <!-- <td colspan="5" class="text-center">No Data Found</td> -->
          </tr>
        </tbody>
      </table>
    </div>
 
    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="cityData?.length >= 1">
      <!-- Entries Message at the Start -->
      <div class="d-flex align-items-center me-3 mb-2">
        <label class="me-2 mb-0">Show</label>
        <select
          class="form-select mt-3 text-center"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange()"
        >
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </option>
        </select>
        <label class="ms-2 mb-0">entries</label>
      </div>
 
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="cityData?.length > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="cityData?.length"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>
 
      <!-- Entries Count Message Aligned to the End -->
      <div *ngIf="cityData?.length > 0" class="text-muted mb-3 ms-3">
        <strong>
          Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > cityData?.length
              ? cityData?.length
              : page * pageSize
          }}
          of {{ cityData?.length }} entries
        </strong>
      </div>
    </div>
  </div>
 
  <!-- Create City Modal -->
  <ng-template #createCityModal let-modal>
    <div class="modal-header custom-modal-header">
      <h5 class="modal-title mt-2">Create City</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>
    <form [formGroup]="createCityForm">
      <div class="modal-body">
        <!-- City Name -->
        <label for="city">City Name</label>
        <input
          type="text"
          class="form-control mt-2"
          formControlName="cityName"
          placeholder="Enter City"
          [ngClass]="{
            'invalid-field':
              createCityForm.controls['cityName'].invalid &&
              createCityForm.controls['cityName'].touched
          }"
          pattern="[A-Za-z\s]*"
        />
 
        <div class="container mt-3 me-5">
          <div class="line-heading">
            <strong>Coordinates</strong>
          </div>
        </div>
 
        <!-- Latitude and Longitude Fields -->
        <div
          class="mt-3"
          style="max-height: 250px; overflow-y: auto; overflow-x: hidden"
        >
          <div class="row align-items-center mb-2">
            <div class="col">
              <label for="latitude">Latitude & Longitude</label>
              <textarea
                class="form-control mt-2"
                formControlName="latandlng"
                rows="6"
                placeholder="Enter Latitude & Longitude"
                [ngClass]="{
                  'invalid-field':
                    createCityForm.controls['latandlng'].invalid &&
                    createCityForm.controls['latandlng'].touched
                }"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="addCity(modal)">
          {{ isEditMode ? "Update" : "Submit" }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="modal.dismiss()"
        >
          Cancel
        </button>
      </div>
    </form>
  </ng-template>
 
  <!-- Change Status Modal -->
  <ng-template #activePopup let-modal>
    <!-- Modal Header -->
    <div class="modal-header custom-modal-header">
      <h5 class="modal-title mt-2">Change City Status</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>
 
    <!-- Modal Body -->
    <div class="modal-body">
      <p>
        Are you sure you want to change the status of the city "<strong>{{
          currentCityForStatusChange.cityName
        }}</strong
        >" to
        <strong>
          {{
            currentCityForStatusChange.cityStatus === true ||
            currentCityForStatusChange.cityStatus === "true"
              ? "Inactive"
              : "Active"
          }} </strong
        >?
      </p>
    </div>
 
    <!-- Modal Footer -->
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="changeCityStatus(modal)"
      >
        <i class="bi bi-check-circle me-2"></i> Confirm
      </button>
      <button type="button" class="btn btn-primary" (click)="modal.dismiss()">
        <i class="bi bi-x-circle me-2"></i> Cancel
      </button>
    </div>
  </ng-template>
</div>

<ng-template #deleteZoneModal let-modal>
  <div class="modal-header custom-modal-header">
    <h5 class="modal-title mt-2">Confirm Delete</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    >
      X
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this city? This action cannot be undone.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="deleteZoneByZoneID(modal)">
      Yes
    </button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      No
    </button>
  </div>
</ng-template>
 
<app-loader *ngIf="isPageloading"></app-loader>